(function () {
  const DEBUG = false;
  const log = (...a) => DEBUG && console.log('[addons]', ...a);

  // --- money helpers ---
  function formatMoney(cents) {
    try {
      const cur = (Shopify && Shopify.currency && Shopify.currency.active) || undefined;
      return new Intl.NumberFormat(undefined, { style: 'currency', currency: cur }).format((cents || 0) / 100);
    } catch { return ((cents || 0) / 100).toFixed(2); }
  }
  function exVatCents(grossCents, vatRate, pricesIncludeTax, showExVat) {
    if (!showExVat) return grossCents;
    return pricesIncludeTax ? Math.round((grossCents || 0) / (1 + vatRate)) : grossCents;
  }

  // --- find the real add-to-cart form (not the installment form) ---
  function findProductForm() {
    const forms = Array.from(document.querySelectorAll('form[action*="/cart/add"]'));
    // Prefer a form that actually contains an add-to-cart submit button
    const withSubmit = forms.find(f => f.querySelector('[name="add"], .product-form__submit, [type="submit"]'));
    return withSubmit || forms[0] || null;
  }
  function findVariantIdInput(form) {
    return form && (form.querySelector('input[name="id"]') || form.querySelector('[name="id"]'));
  }

  // --- product JSON (variant map) ---
  function getProductJson() {
    const s = document.querySelector('script[type="application/json"][id^="ProductJson-"]');
    if (!s) return null;
    try { return JSON.parse(s.textContent.trim()); } catch { return null; }
  }

  // --- build main line item with qty/selling_plan/properties preserved ---
  function mainLineItemFromForm(form) {
    const fd = new FormData(form);
    const id = Number(fd.get('id'));
    const quantity = Number(fd.get('quantity') || 1) || 1;
    const item = { id, quantity };
    const sp = fd.get('selling_plan'); if (sp) item.selling_plan = sp;
    const props = {};
    fd.forEach((v, k) => { if (k.startsWith('properties[') && k.endsWith(']')) props[k.slice(11, -1)] = v; });
    if (Object.keys(props).length) item.properties = props;
    return item;
  }

  // --- main price updater (ex VAT) ---
  function wireMainPrice() {
    const addonsRoot = document.getElementById('variant-addons');
    const ex = addonsRoot ? addonsRoot.getAttribute('data-exvat') === 'true' : true;
    const rate = addonsRoot ? Number(addonsRoot.getAttribute('data-vat-rate') || 0.20) : 0.20;
    const incl = addonsRoot ? addonsRoot.getAttribute('data-prices-include-tax') === 'true' : false;

    const target = document.querySelector('[data-exvat-price]') || document.querySelector('.price .price-item--regular');
    const form = findProductForm();
    const idInput = findVariantIdInput(form);
    const productData = getProductJson();

    if (!target || !form || !idInput || !productData) {
      log('price wiring skipped', { hasTarget: !!target, hasForm: !!form, hasId: !!idInput, hasJson: !!productData });
      return;
    }

    function applyByVariantId(vid) {
      const v = productData.variants && productData.variants.find(x => Number(x.id) === Number(vid));
      if (!v) { log('variant not in JSON', vid); return; }
      const net = exVatCents(Number(v.price), rate, incl, ex);
      target.textContent = formatMoney(net) + ' (ex VAT)';
    }

    // initial
    applyByVariantId(idInput.value);

    // respond to variant changes
    const obs = new MutationObserver(() => applyByVariantId(idInput.value));
    obs.observe(idInput, { attributes: true, attributeFilter: ['value'] });
    idInput.addEventListener('change', () => applyByVariantId(idInput.value));
    document.addEventListener('variant:change', (e) => { const v = e.detail && e.detail.variant; if (v && v.id) applyByVariantId(v.id); });
  }

  // --- add-ons UI: row prices, subtotal, bundling ---
  function initAddons() {
    const root = document.getElementById('variant-addons');
    if (!root) return;

    const ex = root.getAttribute('data-exvat') === 'true';
    const rate = Number(root.getAttribute('data-vat-rate') || 0);
    const incl = root.getAttribute('data-prices-include-tax') === 'true';
    const subtotalEl = root.querySelector('.addons-subtotal');
// Hard reset any prefilled values (browser autofill / previous session)
root.querySelectorAll('.quantity__input').forEach((i) => {
  // only touch add-on qty inputs (not the main product qty)
  if (i.name && i.name.startsWith('addon-quantity-')) {
    i.value = '0';
    i.setAttribute('value', '0');       // keep attribute in sync for Dawn's component
    i.dispatchEvent(new Event('change', { bubbles: true })); // trigger recalculation
  }
});

    // show each row price ex VAT
    root.querySelectorAll('.addon-row').forEach(row => {
      const gross = Number(row.getAttribute('data-addon-price') || 0);
      const net = exVatCents(gross, rate, incl, ex);
      const node = row.querySelector('.addon-price');
      if (node) node.textContent = formatMoney(net);
    });

    function calcGross() {
      let cents = 0;
      root.querySelectorAll('.addon-row').forEach(row => {
        const qty = Number(row.querySelector('.quantity__input')?.value || 0);
        const price = Number(row.getAttribute('data-addon-price') || 0);
        cents += qty * price;
      });
      return cents;
    }
    function recalc() {
      const gross = calcGross();
      const net = exVatCents(gross, rate, incl, ex);
      subtotalEl.dataset.cents = String(net);
      subtotalEl.textContent = formatMoney(net);
    }
    root.querySelectorAll('.quantity__input').forEach(i => {
      i.addEventListener('input', recalc);
      i.addEventListener('change', recalc);
    });
    recalc();

    // bundle submit (Add to cart + Dynamic checkout)
    const form = findProductForm();
    if (!form || form.__addonsBound) return;
    form.__addonsBound = true;

    function selectedAddons() {
      const items = [];
      root.querySelectorAll('.addon-row').forEach(row => {
        const qty = Number(row.querySelector('.quantity__input')?.value || 0);
        const id = Number(row.getAttribute('data-addon-variant-id') || 0);
        if (qty > 0 && id) items.push({ id, quantity: qty });
      });
      return items;
    }

    form.addEventListener('submit', (evt) => {
      const addons = selectedAddons();
      if (!addons.length) return; // native flow if none picked

      evt.preventDefault();

      const mainItem = mainLineItemFromForm(form);
      const items = [mainItem, ...addons];

      const submitter = evt.submitter || null;
      const toCheckout =
        !!submitter &&
        (submitter.name === 'checkout' ||
         submitter.classList.contains('shopify-payment-button__button') ||
         submitter.closest('.shopify-payment-button'));

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items })
      })
      .then(r => { if (!r.ok) throw new Error('add_failed'); return r.json(); })
      .then(() => {
        if (toCheckout) {
          window.location.href = '/checkout';
        } else {
          document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          if (!document.querySelector('cart-drawer, cart-drawer-items')) window.location.href = '/cart';
        }
      })
      .catch(() => form.submit()); // fallback adds main item at least
    });
  }

  function mount() {
    wireMainPrice();
    initAddons();
  }

  document.addEventListener('DOMContentLoaded', mount);
  ['shopify:section:load','shopify:section:reorder','shopify:section:select','shopify:section:deselect','shopify:block:select','shopify:block:deselect']
    .forEach(ev => document.addEventListener(ev, mount));
})();
